var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7, _path8, _path9, _defs3, _path10, _defs4, _path11, _defs5, _path12, _defs6, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagrams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000169519848987210132800000005409194060498409345_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000087380530972662992980000010068636232512724123_);}\r\n\t.st5{clip-path:url(#SVGID_00000072244360528825769430000012535464106487240339_);}\r\n\t.st6{clip-path:url(#SVGID_00000161629405549516658310000010407451611541381039_);}\r\n\t.st7{clip-path:url(#SVGID_00000183943043488005205770000015815326411611100863_);}\r\n\t.st8{clip-path:url(#SVGID_00000002344667319463140110000008788106160625084293_);}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080182341169262192360000008373141198404636044_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080182341169262192360000008373141198404636044_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160170510495124966080000008129479341080301727_",
    x: 13.2,
    y: 21.2,
    width: 64.3,
    height: 64.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000934609402480059370000011970636176719769996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160170510495124966080000008129479341080301727_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000934609402480059370000011970636176719769996_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6,57.4c-0.3-2.9-0.5-6.2-0.5-8.8c0-5.4,0-19.6-9.6-19.6c-11,0-17.9,26-17.9,39.7c0,2.1,0,12.3,3.5,15.5 c0.8,0.8,1.9,1.3,2.9,1.3c2.4,0,3.8-1.1,4.8-1.9c1.3-1.1,3.5-2.7,8.6-4C43.7,76.4,42.4,66.2,41.6,57.4z M31.9,75.3 c-5.9,1.6-8.3,3.5-9.9,4.8c-1.1,0.8-1.3,1.1-2.1,1.1c-1.1-0.8-2.1-7-2.1-12.6c0-15.5,7.5-35.4,13.7-35.4c3.8,0,5.4,4.8,5.4,15.3 c0,3.2,0.3,6.4,0.8,9.4C38.4,67.5,38.6,73.4,31.9,75.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5,68.6c0-13.7-7-39.7-17.9-39.7c-9.6,0-9.6,14.2-9.6,19.6c0,2.9-0.3,5.9-0.5,8.8c-1.1,8.8-2.1,19,8.3,22 c5.1,1.6,7,2.9,8.6,4c1.3,1.1,2.7,1.9,4.8,1.9c1.1,0,2.1-0.5,2.9-1.3C77.5,80.7,77.5,70.5,77.5,68.6z M71,81.2 c-0.8,0-1.1-0.3-2.4-1.1c-1.6-1.3-4-3.2-9.9-4.8c-6.7-1.9-6.4-7.5-5.4-17.4c0.3-3.2,0.8-6.2,0.8-9.4s0-7.8,1.1-11 c1.1-3.8,2.9-4.3,4.3-4.3c5.9,0,13.7,19.8,13.7,35.4C73.2,74.2,72.1,80.4,71,81.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,47.7c-0.5,0-2.1,0-3.2-3.5c-0.3-0.8-1.1-1.3-1.9-1.3s-1.6,0.5-1.9,1.3c-1.3,3.5-2.9,3.5-3.2,3.5 c-1.1,0-2.1,1.1-2.1,2.1c0,1.1,1.1,2.1,2.1,2.1c1.6,0,3.5-0.5,5.4-2.7c1.6,2.1,3.8,2.7,5.4,2.7c1.1,0,2.1-1.1,2.1-2.1 C52.8,48.5,51.8,47.7,50.7,47.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,21.2c-1.1,0-2.1,0.8-2.1,2.1v22c0,1.1,1.1,2.1,2.1,2.1c1.1,0,2.1-1.1,2.1-2.1v-22C47.5,22.3,46.4,21.2,45.3,21.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024003586850380132290000010343363026935471536_",
    x: 61.7,
    y: 28.7,
    width: 26.8,
    height: 26.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086693932326712233820000016214433008621476509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024003586850380132290000010343363026935471536_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086693932326712233820000016214433008621476509_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4,41H62.8c-0.7,0-1.1,0.4-1.1,1.1s0.4,1.1,1.1,1.1h24.6c0.7,0,1.1-0.4,1.1-1.1S88,41,87.4,41z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098178513225232736220000001448060343604608421_",
    x: 72.3,
    y: 66.7,
    width: 16.2,
    height: 26.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176730488160887704390000006006188597773057723_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098178513225232736220000001448060343604608421_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176730488160887704390000006006188597773057723_)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8,78.9H73c-0.4,0-0.7,0.4-0.7,1.1c0,0.7,0.3,1.1,0.7,1.1h14.8c0.4,0,0.7-0.4,0.7-1.1C88.5,79.4,88.2,78.9,87.8,78.9z "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004528595410352174390000012536124211841710487_",
    x: 45.3,
    y: 11.9,
    width: 43.2,
    height: 26.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065794206785889735640000001978042596799756933_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004528595410352174390000012536124211841710487_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065794206785889735640000001978042596799756933_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7,24.2H47.1c-1.1,0-1.8,0.4-1.8,1.1c0,0.7,0.7,1.1,1.8,1.1h39.6c1.1,0,1.8-0.4,1.8-1.1 C88.5,24.7,87.8,24.2,86.7,24.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179612049565693868970000006685981362480209572_",
    x: 69.1,
    y: 49.3,
    width: 19.4,
    height: 25
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009563194988985045530000012993569350877257362_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179612049565693868970000006685981362480209572_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009563194988985045530000012993569350877257362_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7,60.7H69.9c-0.5,0-0.8,0.4-0.8,1c0,0.6,0.3,1,0.8,1h17.8c0.5,0,0.8-0.4,0.8-1C88.5,61.1,88.2,60.7,87.7,60.7z"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M82,97.3H21.4c-8.2,0-14.8-6.6-14.8-14.8V21.9c0-8.2,6.6-14.8,14.8-14.8H82c8.2,0,14.8,6.6,14.8,14.8v60.6 C96.8,90.7,90.2,97.3,82,97.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagrams);
export default __webpack_public_path__ + "static/media/diagrams.7682bb898101c2d5c0004b1fe286449f.svg";
export { ForwardRef as ReactComponent };